import {StyleSheet, Text, View} from "react-native";
import {Color} from "@/lib/styles";

type Props = {
    text: string,
}
export default function Message({text}: Props) {
    return (
        <View style={styles.container}>
            <Text style={styles.text}>{text}</Text>
        </View>
    )
}

export const styles = StyleSheet.create({
    container: {
        backgroundColor: Color.BackgroundContainer,
        borderRadius: 8,
        paddingHorizontal: 12,
        paddingVertical: 12,
    },
    text: {
        color: Color.PrimaryText,
        fontSize: 16,
        lineHeight: 22,
        width: "100%",
    },
})